import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import GlitchText from './GlitchText';
import TextPressure from './TextPressure';
import DecryptedText from './DecryptedText';
import FuzzyText from './FuzzyText';
import VariableProximity from './VariableProximity';

const NewServices = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const [activeService, setActiveService] = useState(null);
    const [stickyTop, setStickyTop] = useState(0);
    const proximityContainerRef = useRef(null);

    useEffect(() => {
        const calculateStickyTop = () => {
            const viewportHeight = window.innerHeight;
            const imageHeight = 400;
            setStickyTop(viewportHeight / 2 - imageHeight / 2);
        };
        calculateStickyTop();
        window.addEventListener('resize', calculateStickyTop);
        return () => window.removeEventListener('resize', calculateStickyTop);
    }, []);

    const services = [
        {
            key: 'dental_anxiety',
            title: t('new_services.services.dental_anxiety.title'),
            subtitle: t('new_services.services.dental_anxiety.subtitle'),
            img: '/new images/anxiety patient.png',
        },
        {
            key: 'aesthetic_dentistry',
            title: t('new_services.services.aesthetic_dentistry.title'),
            subtitle: t('new_services.services.aesthetic_dentistry.subtitle'),
            img: '/Assets/DENTISTRY.jpg',
        },
        {
            key: 'implantology',
            title: t('new_services.services.implantology.title'),
            subtitle: t('new_services.services.implantology.subtitle'),
            img: '/Assets/implantology.jpg',
        },
        {
            key: 'root_canal_therapy',
            title: t('new_services.services.root_canal_therapy.title'),
            subtitle: t('new_services.services.root_canal_therapy.subtitle'),
            img: '/new images/miko cleaned.png',
        },
        {
            key: 'dental_prosthetics',
            title: t('new_services.services.dental_prosthetics.title'),
            subtitle: t('new_services.services.dental_prosthetics.subtitle'),
            img: '/Assets/DENTAL PROSTHETICS.jpg',
        },
        {
            key: 'oral_surgery',
            title: t('new_services.services.oral_surgery.title'),
            subtitle: t('new_services.services.oral_surgery.subtitle'),
            img: '/new images/ORALCHIRURGIE.png',
        },
        {
            key: 'orthodontics',
            title: t('new_services.services.orthodontics.title'),
            subtitle: t('new_services.services.orthodontics.subtitle'),
            img: '/Assets/Orthodontics Invisalign.jpg',
        },
        {
            key: 'paediatric_dentistry',
            title: t('new_services.services.paediatric_dentistry.title'),
            subtitle: t('new_services.services.paediatric_dentistry.subtitle'),
            img: '/Assets/Paediatric Dentistry.jpg',
        },
        {
            key: 'professional_cleaning',
            title: t('new_services.services.professional_cleaning.title'),
            subtitle: t('new_services.services.professional_cleaning.subtitle'),
            img: '/new images/prophylaxe.png',
        },
        {
            key: 'bleaching',
            title: t('new_services.services.bleaching.title'),
            subtitle: t('new_services.services.bleaching.subtitle'),
            img: '/new images/bleaching cleaned 2 .png',
        },
        {
            key: 'periodontitis_therapy',
            title: t('new_services.services.periodontitis_therapy.title'),
            subtitle: t('new_services.services.periodontitis_therapy.subtitle'),
            img: '/Assets/Periodontitis Therapy.jpg',
        },
    ];

    return (
        <div className="bg-[#e8e2d4] text-gray-400 min-h-screen flex items-center font-sans relative pb-32">
            <div className="w-full mx-auto px-12 relative">
        
        
                
                <div className={`uppercase flex mb-2 ${i18n.language === 'ar' ? 'justify-end' : 'justify-start'}`}>
                    <div className={i18n.language === 'ar' ? 'inline-block ml-auto mr-8 md:mr-16 lg:mr-16' : 'inline-block'}>
                    <FuzzyText 
                  
                        baseIntensity={0.0} 
                        hoverIntensity={0.2} 
                        enableHover={true}
                        color="#422f40"
                        fontSize="clamp(1rem, 5vw, 5rem)"                        fontWeight={800}
                        fontFamily={i18n.language === 'ar' ? 'RH-Zak, sans-serif' : 'inherit'}
                    >
                        {t('new_services.title').toUpperCase()}
                    </FuzzyText>
                    </div>
                </div>
                <div className={`flex mb-20 ${i18n.language === 'ar' ? 'justify-end' : 'justify-start'} ${i18n.language === 'ar' ? 'mr-8 md:mr-16 lg:mr-16' : 'ml-20'}`}>
                    <p className={`text-lg text-gray-600 leading-relaxed max-w-4xl ${i18n.language === 'ar' ? 'text-right' : 'text-center'}`} style={i18n.language === 'ar' ? { direction: 'rtl' } : {}}>
                        {t('new_services.description')}
                    </p>
                </div>
                <div className="flex items-start relative">
                    <div className="flex-grow">
                        {/* <div className="flex mb-12">
                            <div className="w-1/6"></div>
                            <div className="flex-grow">
                                <p className="text-lg text-gray-600 leading-relaxed max-w-2xl">
                                    <DecryptedText
                                        text="Comprehensive care tailored to you — from routine check-ups and aesthetic treatments to advanced dental solutions. We prioritize your comfort by providing services in your language and at your pace. Our dedicated team stays updated through continuous training, using only state-of-the-art technology to ensure the highest quality care."
                                        speed={0.03}
                                        maxIterations={0.03}
                                        sequential={true}
                                        revealDirection="start"
                                        animateOn="view"
                                        useOriginalCharsOnly={true}
                                        className="text-lg text-gray-600 leading-relaxed max-w-2xl"
                                        encryptedClassName="text-lg text-gray-600 leading-relaxed max-w-2xl"
                                    />
                                </p>
                            </div>
                        </div> */}
                        <ul>
                            {services.map((service) => (
                                <li
                                    key={service.key}
                                    className="my-1 h-16 flex items-center"
                                    onMouseEnter={() => setActiveService(service)}
                                    onMouseLeave={() => setActiveService(null)}
                                    onFocus={() => setActiveService(service)}
                                    onBlur={() => setActiveService(null)}
                                    tabIndex="0"
                                >
                                    <Link 
                                        to={`/service/${service.key}`} 
                                        state={{ background: location }}
                                        className="flex items-center w-full no-underline hover:no-underline focus:no-underline"
                                        style={{ textDecoration: 'none' }}
                                    >
                                        <div className="w-1/6">
                                            <div
                                                className={`transition-opacity duration-300 max-w-[20ch] ${
                                                    activeService?.key === service.key ? 'opacity-100' : 'opacity-0'
                                                }`}
                                            >
                                                {activeService?.key === service.key ? (
                                                    <DecryptedText
                                                        text={service.subtitle}
                                                        speed={50}
                                                        maxIterations={10}
                                                        sequential={true}
                                                        revealDirection="start"
                                                        animateOn="view"
                                                        useOriginalCharsOnly={true}
                                                        className="text-sm text-gray-500"
                                                        encryptedClassName="text-sm text-gray-500"
                                                    />
                                                ) : (
                                                    <span className="text-sm text-gray-500">{service.subtitle}</span>
                                                )}
                                            </div>
                                            
                                        </div>
                                        <div className="flex-grow">
                                            <h2
                                                className={`uppercase text-4xl lg:text-5xl font-bold transition-all duration-300 cursor-pointer break-words leading-tight ${
                                                    activeService?.key === service.key ? 'text-[#422f40] translate-x-10' : ''
                                                }`}
                                            >
                                                {service.title}
                                            </h2>
                                        </div>
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="w-[300px] flex-shrink-0 ml-auto" style={{ height: '400px', top: `${stickyTop}px`, position: 'sticky' }}>
                        <div
                            className={`transition-opacity duration-500 h-full ${
                                activeService ? 'opacity-100' : 'opacity-0'
                            }`}
                        >
                            {activeService && (
                                <img
                                    src={activeService.img}
                                    alt={activeService.title}
                                    className="w-full h-full object-cover rounded-lg"
                                />
                            )}
                        </div>
                    </div>
                </div>
                <div className="text-left mt-24 ml-[16.67%]">
                    <a 
                        href="https://www.doctolib.de/zahnarztpraxis/berlin/die-drei-zahnaerzte/booking/specialities?profile_skipped=true&utm_source=die-drei-zahnaerzte-website-button&utm_medium=referral&utm_campaign=website-button&utm_content=option-8&bookingFunnelSource=external_referral" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="bg-gray-400 hover:bg-[#422f40] text-[#422f40] hover:text-gray-400 font-bold text-lg py-3 px-10 rounded-full transition-colors duration-300 inline-block"
                    >
                        {t('new_services.book_appointment')}
                    </a>
                </div>
            </div>
        </div>
    );
};

export default NewServices; 